module.exports = __webpack_public_path__ + "static/media/IMG_0417.22648151.HEIC";